import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { Create } from '@atlaskit/atlassian-navigation';
import { fg } from '@atlaskit/platform-feature-flags';
import {
	TeamsAppAnalyticsContext,
	useAnalyticsEvents,
} from '@atlaskit/teams-app-internal-analytics';
import {
	addPeopleMessages,
	AnalyticsEventActions,
	AnalyticsEventSource,
	useAnalytics,
	useDialog,
} from '@atlassian/ptc-common';

import LazyAddPeopleDialog from '../../../../../../common/ui/InvitePeopleDialog';
import { useStandaloneFlagActions } from '../../../../../../controllers/flags';
import { useOrgIdState } from '../../../../../../controllers/org-id';
import { useSiteStandaloneApp } from '../../../../../../controllers/site-standalone-app';

const AddPeopleButtonInner = () => {
	const [, { addFlag }] = useStandaloneFlagActions();
	const intl = useIntl();
	const [{ cloudId }] = useSiteStandaloneApp();
	const [{ orgId }] = useOrgIdState();

	const analytics = useAnalytics();
	const { fireEvent } = useAnalyticsEvents();
	const { openDialog } = useDialog();

	const onClick = useCallback(() => {
		if (fg('ptc-enable-ptc-common-analytics-refactor')) {
			fireEvent('ui.button.clicked.addPeopleButton', {
				isPrimary: true,
			});
		} else {
			analytics.pushUIEvent({
				source: AnalyticsEventSource.PEOPLE_HOME,
				actionSubject: 'button',
				actionSubjectId: 'addPeopleButton',
				action: AnalyticsEventActions.CLICKED,
				attributes: { isPrimary: true },
			});
		}

		openDialog(LazyAddPeopleDialog, {
			source: 'peopleDirectoryMenuButton',
			addFlag,
			cloudId,
			orgId,
		});
	}, [addFlag, analytics, cloudId, openDialog, orgId, fireEvent]);

	if (fg('ptc-enable-ptc-common-analytics-refactor')) {
		return (
			<TeamsAppAnalyticsContext data={{ source: AnalyticsEventSource.PEOPLE_HOME }}>
				<Create
					text={intl.formatMessage(addPeopleMessages.addPeopleButtonLabel)}
					onClick={onClick}
				/>
			</TeamsAppAnalyticsContext>
		);
	}

	return (
		<Create text={intl.formatMessage(addPeopleMessages.addPeopleButtonLabel)} onClick={onClick} />
	);
};

export const AddPeopleButton = (): React.JSX.Element => {
	if (fg('ptc-enable-ptc-common-analytics-refactor')) {
		return (
			<TeamsAppAnalyticsContext data={{ source: AnalyticsEventSource.PEOPLE_HOME }}>
				<AddPeopleButtonInner />
			</TeamsAppAnalyticsContext>
		);
	}
	return <AddPeopleButtonInner />;
};
